<template>
  <b-card>
    <div class="animated fadeIn">
      <b-row class="mb-3">
        <b-col>
          <b-input v-model="keyword" placeholder="Search" />
        </b-col>
        <b-col class="text-right">
          <b-button-group>
            <b-button
              @click="add()"
              v-b-modal.modal
              v-b-tooltip.hover
              title="Add"
              variant="success"
            >
              <i class="fa fa-plus"></i>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-table
        caption-top
        :items="filteredItems"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        head-variant="dark"
      >
        <template slot="index" slot-scope="data">{{ data.index + 1 }}</template>
        <template slot="time" slot-scope="data">{{ data.item.time.seconds | datetime}}</template>
        <template slot="total" slot-scope="data">{{ data.item.total | numberformat }}</template>
        <template slot="reads" slot-scope="data">{{ data.item.reads | numberformat }}</template>
        <template slot="actions" slot-scope="data">
          <b-button-group>
            <b-button
              @click="view(data.item)"
              v-b-modal.modalcustomers
              size="sm"
              v-b-tooltip.hover
              title="Send Push"
              variant="danger"
            >
              <i class="fa fa-send"></i>
            </b-button>
            <b-button
              @click="view(data.item)"
              v-b-modal.modal
              size="sm"
              v-b-tooltip.hover
              title="View"
              variant="warning"
            >
              <i class="fa fa-pencil"></i>
            </b-button>
          </b-button-group>
        </template>
      </b-table>

      <b-pagination
        v-if="filteredItems && filteredItems.length > 0"
        v-model="currentPage"
        :total-rows="filteredItems.length"
        :limit="10"
        align="center"
        size="sm"
        class="mt-3"
      />

      <b-modal
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        id="modal"
        v-if="model"
        :title="model.id ? 'Edit Push':'Add Push'"
        :header-bg-variant="model.id ? 'warning':'success'"
        ok-title="Save"
        @ok="save()"
      >
        <b-form-group label="Title">
          <b-form-input v-model="model.title" />
        </b-form-group>
        <b-form-group label="Subtitle">
          <b-form-input v-model="model.subtitle" />
        </b-form-group>
        <b-form-group label="Descriptions">
          <b-form-textarea v-model="model.description" rows="5" />
        </b-form-group>
      </b-modal>

      <b-modal
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        id="modalcustomers"
        v-if="model && customers"
        :title="'Select Customers (' + (customers ? customers.length : 0) + ')'"
        ok-title="Send"
        size="lg"
        @ok="send()"
      >
        <table class="table" v-if="customers">
          <thead>
            <tr>
              <th>
                <b-checkbox v-model="checkall" @input="doCheckAll()" />
              </th>
              <th>Email</th>
              <th>Name</th>
              <th>Tel</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in customers" :key="index">
              <td>
                <b-checkbox v-model="item.selected" />
              </td>
              <td>{{item.email}}</td>
              <td>{{item.name}}</td>
              <td>{{item.tel}}</td>
            </tr>
          </tbody>
        </table>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";

export default {
  name: "Push",
  computed: {
    filteredItems: function() {
      if (this.keyword)
        return _.filter(this.items, i => {
          if (this.match(this.keyword, i.title)) return true;
          if (this.match(this.keyword, i.subtitle)) return true;
          return false;
        });
      else return this.items;
    },
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  data() {
    return {
      items: null,
      model: null,
      collection: null,
      customers: null,
      checkall: true,
      keyword: null,
      fields: [
        { key: "index", label: "#" },
        { key: "time", sortable: true },
        { key: "title", sortable: true },
        { key: "subtitle", sortable: true },
        { key: "total", sortable: true, class: "text-right" },
        { key: "reads", sortable: true, class: "text-right" },
        { key: "actions", class: "text-right" }
      ],
      currentPage: 1,
      perPage: 20,
      sortDesc: false,
      sortDirection: "asc",
      sortBy: "",
      filter: null
    };
  },
  mounted() {
    this.collection = firebase.firestore().collection("pushes");
    firebase
      .firestore()
      .collection("users")
      .onSnapshot(snapshot => {
        let items = [];
        snapshot.forEach(doc => {
          let item = doc.data();
          item.id = doc.id;
          items.push(item);
          item.selected = true;
        });
        this.customers = items;
      });
    this.gets();
  },
  methods: {
    doCheckAll() {
      this._.map(this.customers, c => (c.selected = this.checkall));
    },
    send() {
      Swal.fire(this.swalsuccess());
    },
    gets() {
      Swal.showLoading();
      this.collection.onSnapshot(snapshot => {
        let items = [];
        snapshot.forEach(doc => {
          let item = doc.data();
          item.id = doc.id;
          items.push(item);
        });
        this.items = items;
        Swal.close();
      });
    },
    add() {
      this.model = {};
    },
    view(item) {
      this.model = item;
    },
    save() {
      this.model.time = firebase.firestore.FieldValue.serverTimestamp();
      if (this.model.id) {
        var id = this.model.id;
        this.collection.doc(this.model.id).set(this.model);
      } else this.collection.add(this.model);
      this.gets();
    }
  }
};
</script>

<style>
</style>
